export const STOP_AUTOSCROLL_THRESHOLD_PX = 100;
